"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayeeInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_hook_form_1 = require("react-hook-form");
const mui_inputs_entity_1 = require("@dzambalaorg/mui-inputs-entity");
const PayeeInput = (props) => {
    const { name, controller = "users" } = props;
    const data = {};
    const form = (0, react_hook_form_1.useFormContext)();
    const handleChange = (_event, option) => {
        form.setValue(name, option?.account ? option?.account : option?.wallet ? option?.wallet : "0x", {
            shouldDirty: true,
        });
        form.setValue(`shares`, option?.shares ?? 0);
    };
    return ((0, jsx_runtime_1.jsx)(mui_inputs_entity_1.EntityInput, { name: name, controller: controller, fetchData: data, onChange: handleChange, getTitle: (payee) => `${payee.account} - ${payee.shares}%` }));
};
exports.PayeeInput = PayeeInput;
//# sourceMappingURL=index.js.map